import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { LogoComponent } from "./logoview/logoview";

@NgModule({
    imports: [BrowserModule, SharedModule],
    declarations: [LogoComponent],
    exports: [LogoComponent],
})
export class Common_Logo {}
